export default __webpack_public_path__ + "static/media/favicon.4a6975ef.ico";